import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UrlParameterService {
  private readonly document: Document = inject(DOCUMENT);

  public has(name: string): boolean {
    return new URLSearchParams(this.document.location.search).has(name);
  }

  public get(name: string): string | null {
    return new URLSearchParams(this.document.location.search).get(name);
  }
}
